<template>
    <span v-html="total"></span>
</template>
<script>
  export default {
    computed: {
      total() {
        if (!this.$store.state.grid.meta.pagination) {
          return 0;
        }
        return this.$store.state.grid.meta.pagination.total;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridTotal.vue